module.exports = __webpack_public_path__ + "static/img/11.ed22c866.jpg";